import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

interface CollectionControlProps {
  isCollecting: boolean;
  onToggleCollection: () => void;
}

export const CollectionControl = ({
  isCollecting,
  onToggleCollection
}: CollectionControlProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Collection Control</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            {isCollecting 
              ? "Currently collecting data from sources" 
              : "Collection is paused"}
          </p>
          <Button
            onClick={onToggleCollection}
            variant={isCollecting ? "destructive" : "default"}
          >
            <RefreshCw className={`h-4 w-4 mr-2 ${isCollecting ? 'animate-spin' : ''}`} />
            {isCollecting ? "Stop Collection" : "Start Collection"}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};